export function getSectionId(block: Record<string, unknown>): string | undefined {
	const sectionId = typeof block.sectionId === 'string' ? block.sectionId.trim() : '';

	return sectionId.length > 0 ? sectionId : undefined;
}
